// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2bkFO","inner":"Form_inner__1b69G","range":"Form_range__19m3D","name":"Form_name__1l2hj","actions":"Form_actions__8iSz2"};